$(document).ready(function(){
    $('#browse-by-contributor button').click(function() {
        $('#browse-by-contributor button').removeClass('btn-contributor-active');
        $('#browse-by-contributor button').addClass('btn-default');

        $(this).removeClass('btn-default');
        $(this).addClass('btn-contributor-active');

        var letter = $(this).text();

        if($('#contributor-list-' + letter).length > 0) {
            /* toggle box */
            toggleElementWithOtherElement('#contributor-list-' + letter, 'div.contributor-list-cnt');
        } else {
            /* load contributors */
            if($("div.contributor-list-cnt:visible").length > 0) {
                $("div.contributor-list-cnt:visible").slideUp(300, function() {
                    loadContributorData(letter);
                });
            } else {
                loadContributorData(letter);
            }

        }
    });

    loadContributorData('A');

    function loadContributorData(letter){
        $('#search-overlay').slideDown(100);

        $.post(loadContributorListUrl, {
            'data': letter
        }, function(data, b) {

            if(data.isError == 1) {
                alert(data.msgError);
            } else {
                var cntContributor = $('<div>')
                    .attr('id', 'contributor-list-' + letter)
                    .attr('style', 'display: none;')
                    .addClass('contributor-list-cnt')
                    .addClass('margin-horizontal-15')
                    .html(data.html);

                $('#browse-by-contributor-lists').append(cntContributor);

                toggleElementWithOtherElement('#contributor-list-' + letter, 'div.contributor-list-cnt');
            }
            $('#search-overlay').slideUp(100);
        });
    }

    function toggleElementWithOtherElement(idToShow, idToHide) {
        if($(idToShow).is(':visible')) {
            $(idToShow).slideToggle(300);
        } else {
            if($(idToHide + ":visible").length > 0) {
                $(idToHide + ":visible").slideToggle(300, function() {
                    $(idToShow).slideToggle(300);
                });
            } else {
                $(idToShow).slideToggle(300);
            }
        }
    }

});